import Vue from 'vue'
import Utility from '../Utility'
import LoadingUpodeta from 'src/components/Loading/LoadingUpodeta.vue'
Vue.prototype.$Utility = Utility
Vue.mixin(LoadingUpodeta)
